import * as Constants from "../common/Constants";

const initialState = {
    distributorReport: [],
    employeeReport: null,
    fromDate: new Date(),
    isLoading: false,
    isPosting: false,
    isPosted: false,
    error: null
};

export default function salesReportReducer(state = initialState, action) {

    switch (action.type) {
        case Constants.REQUEST_GET_DISTRIBUTOR_SALES_REPORT:
        case Constants.REQUEST_GET_EMPLOYEES_SALES_REPORT:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_DISTRIBUTOR_SALES_REPORT:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.distributorReport = action.payload;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEES_SALES_REPORT:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeReport = action.payload;
            return newState;

        case Constants.FAILED_GET_DISTRIBUTOR_SALES_REPORT:
        case Constants.FAILED_GET_EMPLOYEES_SALES_REPORT:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.SUCCESS_GET_FROM_DATE:
            var newState = { ...state };
            newState.fromDate = new Date(action.payload);
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SalesReportReducer.js